var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChinchetaBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2138 7.88051L12.0138 0.0805061C11.7138 -0.119494 11.3138 0.0805063 11.4138 0.380506L11.5138 2.78051C11.5138 2.88051 11.5138 2.98051 11.4138 3.08051L6.01384 9.58051C5.91384 9.68051 5.81384 9.68051 5.71384 9.68051L0.713844 9.88051C0.313844 9.88051 0.213844 10.3805 0.513844 10.5805L6.01384 15.1805L0.213844 21.9805C-0.0861561 22.3805 -0.0861562 22.9805 0.313844 23.3805L0.513844 23.5805C0.913844 23.8805 1.51384 23.8805 1.91384 23.4805L7.61384 16.7805L12.9138 21.1805C13.2138 21.3805 13.6138 21.1805 13.5138 20.7805L12.8138 15.7805C12.8138 15.6805 12.8138 15.5805 12.9138 15.4805L18.3138 8.98051C18.4138 8.88051 18.5138 8.88051 18.6138 8.88051L21.0138 8.58051C21.4138 8.58051 21.5138 8.18051 21.2138 7.88051Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinchetaBlack);
export default __webpack_public_path__ + "static/media/chincheta_black.8991d62dad3b2067aff11073a35cf15b.svg";
export { ForwardRef as ReactComponent };